import React from 'react'

export const Blockquote = (props) => (
    <blockquote
        {...props}
        className="not-prose pt-2 px-4 my-4 rounded bg-accent border border-primary [&_a]:font-semibold [&_a]:underline"
    />
)
